export default __webpack_public_path__ + "static/media/adults.bdc3087b.webp";